import { render, staticRenderFns } from "./UpsellListHeader.vue?vue&type=template&id=e6a00d14&"
import script from "./UpsellListHeader.vue?vue&type=script&lang=js&"
export * from "./UpsellListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports